import { useRef } from 'react';
import PhoneInput, { Country } from 'react-phone-number-input/max';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';
import './InternationalPhoneInput.css';

interface InternationalPhoneInputProps {
  value: string;
  onChange: (value: string, country?: Country) => void;
  defaultCountry?: Country;
  error?: boolean;
  label: string;
  id?: string;
}

export const InternationalPhoneInput = ({
  value,
  onChange,
  defaultCountry = 'US',
  error = false,
  label,
  id,
}: InternationalPhoneInputProps) => {
  const selectedCountry = useRef<Country | undefined>(defaultCountry);

  return (
    <PhoneInput
      id={id}
      className={`guest-phone-input${error ? ' guest-phone-input-error' : ''}`}
      aria-label={label}
      aria-invalid={error}
      defaultCountry={defaultCountry}
      addInternationalOption={false}
      flags={flags}
      value={value || undefined}
      onCountryChange={country => {
        selectedCountry.current = country;
      }}
      onChange={number => onChange(number || '', selectedCountry.current)}
    />
  );
};
